// extracted by mini-css-extract-plugin
module.exports = {"colors":"'./css/vars.module.css'","main_green":"#43D190","black_font":"#4F4F4F"};